/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { date } from '@wordpress/date';
import { Component, Fragment } from '@wordpress/element';
import { InspectorControls, InspectorAdvancedControls } from '@wordpress/block-editor';
import { PanelBody, PanelRow, SelectControl, BaseControl, DateTimePicker, Dropdown, Button } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import PaddingControl from '../../extensions/controls/padding-control';
import MarginControl from '../../extensions/controls/margin-control';
import { generateCustomStyleCode } from '../../extensions/custom-styles';

/**
 * Inspector controls
 */
class Inspector extends Component {
	constructor( props ) {
		super( props );
		this.updateStyles = this.updateStyles.bind( this );
	}

	updateStyles( styles ) {
		const { setAttributes, clientId } = this.props;

		setAttributes( { blockClientId: clientId } );
		generateCustomStyleCode( styles, { ...this.props }, true );
		setAttributes( { blockAdvanceOptions: styles } );
	}

	render() {
		const { attributes, setAttributes } = this.props;
		const { language, dateTime } = attributes;
		return (
			<Fragment>
				<InspectorAdvancedControls>
					<PaddingControl
						{ ...this.props }
						parentKey="blockAdvanceOptions"
						label={ __( 'Padding' ) }
						id="map-padding-id"
						property="padding"
					/>
					<hr />
					<MarginControl
						{ ...this.props }
						parentKey="blockAdvanceOptions"
						label={ __( 'Margin' ) }
						id="map-margin-id"
					/>
					<hr />
				</InspectorAdvancedControls>
				<InspectorControls>
					<PanelBody
						/* translators: block settings */
						title={ __( 'General options' ) }
					>
						<BaseControl>
							<PanelRow>
								<label htmlFor="date-time-field">{ __( 'Date & Time' ) }</label>

								<Dropdown
								// className="my-container-class-name"
									contentClassName="gutenify-dropdown-popup-wrapper"
									position="bottom right"
									renderToggle={ ( { isOpen, onToggle } ) => (
										<Button onClick={ onToggle } aria-expanded={ isOpen } isLink={ true } id="date-time-field" className="gutenify-button-link">{ date( 'M d, Y h:i a', dateTime ) }
										</Button>
									) }
									renderContent={ () => (
										<DateTimePicker currentDate={ dateTime } onChange={ ( value ) => {
											setAttributes( { dateTime: value } );
										} } />
									) }
								/>
							</PanelRow>
						</BaseControl>
						<SelectControl
							label={ __( 'Language', 'ultimate-addons-for-gutenberg' ) }
							value={ language }
							onChange={ ( value ) => setAttributes( { language: value } ) }
							options={ [] }
						/>
					</PanelBody>
				</InspectorControls>
			</Fragment>
		);
	}
}

export default Inspector;
